import { useDragScroll } from "shared/hooks/useDragScroll";
import styles from "styles/pages/reports/reports.module.scss";

export default function ContemplationXUses({ data }) {
  const days = ["dom", "seg", "ter", "qua", "qui", "sex", "sab"];
  const labelDays = {
    dom: "DOM",
    seg: "SEG",
    ter: "TER",
    qua: "QUA",
    qui: "QUI",
    sex: "SEX",
    sab: "SÁB",
  };

  const rows = days.map((origin) => {
    const values = days.map((destination) => {
      const key = `${origin}__${destination}`;
      const value = data?.[key];
      return value !== undefined ? Number(value) : null;
    });

    return {
      status: `ADICIONADO ${labelDays[origin]}`,
      values,
    };
  });

  const maxValue = Math.max(
    ...rows.flatMap((row) => row.values.filter((v) => v !== null))
  );

  const getShade = (value) => {
    if (!value || +value === 0) {
      return {
        background: "#1e1e1f",
        color: "#808080",
      };
    }

    const intensity = Math.min(Math.max(value / maxValue, 0), 1);
    const alpha = 0.6 + intensity * 1;

    return {
      background: `rgba(97, 97, 255, ${intensity})`,
      color: `rgba(255, 255, 255, ${alpha})`,
    };
  };

  const { scrollRef, onMouseDown } = useDragScroll();

  return (
    <div className={styles.box}>
      <div className="d-flex align-center gap-5">
        <p className={styles.label}>Contemplação x Usos</p>
        <span
          className={styles.info}
          title="Cruzamento entre o momento da adição do cupon e o momento do uso do mesmo."
        >
          <i className="fal fa-info-circle" />
        </span>
      </div>

      <div className={styles.hairline} />

      <div
        className={styles.tableTransitions}
        onMouseDown={onMouseDown}
        ref={scrollRef}
      >
        <table>
          <thead>
            <tr>
              <th
                style={{
                  width: "12.5%",
                  backgroundColor: "#1F1F1F",
                  verticalAlign: "middle",
                  color: "#4C4C4C",
                }}
              >
                <i className="far fa-arrow-turn-right" />
              </th>
              <th style={{ width: "12.5%" }}>USOU DOM</th>
              <th style={{ width: "12.5%" }}>USOU SEG</th>
              <th style={{ width: "12.5%" }}>USOU TER</th>
              <th style={{ width: "12.5%" }}>USOU QUA</th>
              <th style={{ width: "12.5%" }}>USOU QUI</th>
              <th style={{ width: "12.5%" }}>USOU SEX</th>
              <th style={{ width: "12.5%" }}>USOU SÁB</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.status}>
                <td className={styles.status} style={{ width: "12.5%" }}>
                  {row.status}
                </td>
                {row.values.map((value, idx) => {
                  const style = getShade(value);

                  return (
                    <td
                      key={idx}
                      style={{
                        backgroundColor: style.background,
                        color: style.color,
                        width: "12.5%",
                      }}
                    >
                      {value || "---"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
